import state from '../state';
import type { Screen } from '../types';

export function transitionScreen(nextScreen: Screen) {
  state.nextScreen = nextScreen;
  setTimeout(() => {
    state.currentScreen = nextScreen;
    state.nextScreen = undefined;
  }, 250);
}
